import { render } from "./CreativeAI.vue?vue&type=template&id=2f074ba3"
import script from "./CreativeAI.vue?vue&type=script&lang=js"
export * from "./CreativeAI.vue?vue&type=script&lang=js"

import exportComponent from "/Users/voltz/Documents/Github/Website/CraftMasters/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__